import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=545c6bfc&"
import script from "./CouponDetail.vue?vue&type=script&lang=js&"
export * from "./CouponDetail.vue?vue&type=script&lang=js&"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports